import script from "./StatusCards.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusCards.vue?vue&type=script&setup=true&lang=js"

import "./StatusCards.vue?vue&type=style&index=0&id=9f3f142e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f3f142e"]])

export default __exports__